export default __webpack_public_path__ + "static/media/feeling.e6778d3a.mp3";